import React, { Component } from 'react'
import PropTypes from 'prop-types'
import queryString from 'query-string'
import update from 'immutability-helper'
import { connect } from 'react-redux'
import { DeleteOutlineOutlined } from '@material-ui/icons'
import {
  IconButton,
  Typography,
  withStyles,
} from '@material-ui/core'

import {
  getOrder,
  addOrder,
  editOrder,
} from '../actions/order'
import {
  generateId,
  validateEmail,
  validatePhone,
} from '../helpers'
import { ECHOCHEQUES_CLIENT_ID, ROUTES } from '../constant'
import Line from '../components/Line'
import Panel from '../components/Panel'
import Button from '../components/Button'
import Inline from '../components/Inline'
import SelectClient from './SelectClient'
import UploadCSV from '../components/UploadCSV'
import InputText from '../components/InputText'


const styles = theme => ({
  root: {
    padding: theme.spacing(1),
  },
  formLine: {
    marginTop: theme.spacing(1),
  },
  contact: {
    width: '100%',
    maxWidth: 900,
    margin: '0 auto',
    padding: theme.spacing(2),
    paddingTop: 0,
    marginTop: theme.spacing(2),
    border: '1px solid #d9dee3',
  },
  reinit: {
    margin: '0 auto',
    marginTop: theme.spacing(1),
  },
  warningTypo: {
    marginTop: theme.spacing(2),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
})


class AddOrder extends Component {
  /* LIFECYCLE */

  /**
   * @constructor
   * @param {*} props - Properties of Component
   */
  constructor(props) {
    super(props)

    this.state = {
      errorMax: false,
      isEdition: false,
      errorAmount: false,
      ...this.getDefaultFormValues(),
    }
  }

  /**
   * @componentDidMount
   */
  componentDidMount() {
    const { location, item } = this.props
    const { uid } = queryString.parse(location.search)

    if (uid && item.id !== uid) {
      this.props.getOrder(uid)
    } else if (uid && item.id === uid) {
      this.synchronizeItem(item)
    }
  }

  /**
   * @componentWillReceiveProps
   * @param {*} nextProps - Next properties of the Component
   */
  componentWillReceiveProps(nextProps) {
    const { location, item } = nextProps

    if ((location !== this.props.location) || (item !== this.props.item)) {
      const { uid } = queryString.parse(location.search)

      if (uid && item.id !== uid) {
        this.props.getOrder(uid)
      } else {
        this.synchronizeItem(item)
      }
    }
  }


  /* METHODS */

  getDefaultFormValues = () => ({
    users: [],
    amount: 0,
    client_id: '',
    users_count: 0,
    bill_number: '',
    informations: '',
    payment_choice: '',
    amount_per_user: 0,
    technical_costs: '',
  })

  synchronizeItem = item => this.setState({
    isEdition: true,
    amount: item.amount,
    client_id: item.client_id,
    users_count: item.users_count,
    bill_number: item.bill_number || '',
    informations: item.informations || '',
    amount_per_user: item.amount_per_user,
    payment_choice: item.payment_choice || '',
    technical_costs: item.technical_costs || '',
  })

  getFormValues = () => {
    const { clients } = this.props
    const values = Object.keys(this.getDefaultFormValues()).reduce((acc, key) => {
      acc[key] = this.state[key]

      return acc
    }, {})

    const client = values.client_id ? clients.find(c => c.id === values.client_id) : ''
    const client_name = (client && client.name) || ''

    values.client_name = client_name
    values.users.forEach((user) => {
      delete user.key
      delete user.errorEmail
      delete user.errorPhone

      user.client_id = values.client_id
      user.client_name = client_name
    })

    return values
  }

  handleChange = e => this.setState({ [e.target.name]: e.target.value })

  handleAmountChange = (e) => {
    this.setState({ errorAmount: false })

    return this.handleChange(e)
  }

  handleUpdateAmountPerUser = () => {
    const { users_count, amount, client_id } = this.state

    if (users_count && amount) {
      const maxAmount = 999 * users_count
      const amount_per_user = amount / users_count
      const isWholeNumber = amount_per_user === Math.floor(amount_per_user)

      if (amount > maxAmount && client_id !== ECHOCHEQUES_CLIENT_ID) {
        return this.setState({
          errorMax: true,
          amount_per_user: 0,
          errorAmount: false,
        })
      }

      return this.setState({
        errorMax: false,
        errorAmount: !isWholeNumber,
        amount_per_user: isWholeNumber ? amount_per_user : 0,
        users: new Array(users_count).fill(0).map(() => ({
          phone: '',
          email: '',
          errorEmail: false,
          errorPhone: false,
          key: generateId(),
          balance: amount_per_user,
        })),
      })
    }

    return null
  }

  handleUserChange = index => (e) => {
    this.setState({
      users: update(this.state.users, {
        [index]: {
          [e.target.name]: { $set: e.target.value },
        },
      }),
    })
  }

  isSubmitable = () => {
    const { errorMax, errorAmount } = this.state

    if (this.props.isLoading || errorMax || errorAmount) {
      return false
    }

    const {
      bill_number,
      informations,
      payment_choice,
      technical_costs,
      ...values
    } = this.getDefaultFormValues()

    return Object.keys(values).every(key => !!this.state[key])
      && this.state.users.every(user => !user.errorEmail && !user.errorPhone)
  }

  handleValidateEmail = index => (e) => {
    const { value } = e.target

    this.setState({
      users: update(this.state.users, {
        [index]: {
          errorEmail: { $set: value ? validateEmail(value) : false },
        },
      }),
    })
  }

  handleValidatePhone = index => (e) => {
    const { value } = e.target
    const nextValue = validatePhone(value)

    return this.setState({
      users: update(this.state.users, {
        [index]: {
          errorPhone: { $set: !nextValue },
          phone: { $set: nextValue || value || '' },
        },
      }),
    })
  }

  handleImportCSV = (e) => {
    const { value } = e.target

    return this.setState({
      users: this.state.users.map((user, index) => {
        const currentValue = value[index]

        if (!currentValue) {
          return user
        }

        const phone = validatePhone(currentValue.phone)
        const emailValidated = currentValue.email ? validateEmail(currentValue.email) : false

        return {
          ...user,
          errorPhone: !phone,
          email: currentValue.email,
          errorEmail: emailValidated,
          phone: phone || currentValue.phone,
        }
      }),
    })
  }

  handleSubmit = async () => {
    if (!this.isSubmitable()) {
      return false
    }

    const { isEdition } = this.state
    const { item } = this.props

    if (isEdition) {
      await this.props.editOrder(item.id, this.getFormValues())
      return this.props.history.push(`${ROUTES.ORDER}/${item.id}`)
    }

    const validated = await this.props.addOrder(this.getFormValues())

    if (validated) {
      this.setState(this.getDefaultFormValues())
    }

    return null
  }

  createSplitUserHandler = (index) => () => {
    this.setState({
      users: update(this.state.users, {
        $splice: [[index, 1]],
      }),
    })
  }


  /* RENDER */

  /**
   * @render
   * @returns {JSX}
   */
  render() {
    const {
      classes,
      isLoading,
    } = this.props
    const {
      errorMax,
      isEdition,
      errorAmount,

      users,
      amount,
      client_id,
      bill_number,
      users_count,
      informations,
      payment_choice,
      technical_costs,
      amount_per_user,
    } = this.state

    const emailDuplicates = users
      .filter((user, index) => user.email && users.findIndex(u => u.email === user.email) !== index)
      .map(user => user.email)
    const phoneDuplicates = users
      .filter((user, index) => user.phone && users.findIndex(u => u.phone === user.phone) !== index)
      .map(user => user.phone)
    const errorDuplicate = emailDuplicates.length + phoneDuplicates.length > 0

    return (
      <div className={classes.root}>
        <Line>Créer une nouvelle commande</Line>

        <form noValidate>

          <Panel title="Client*">
            <SelectClient
              withAdd
              withRefresh
              name="client_id"
              value={client_id}
              onChange={this.handleChange}
            />
          </Panel>

          <Panel title="Détail sur le paiement">
            <InputText
              fullWidth
              name="bill_number"
              value={bill_number}
              label="Numéro de facture"
              onChange={this.handleChange}
            />

            <Inline>
              <InputText
                fullWidth
                name="payment_choice"
                value={payment_choice}
                label="Mode de règlement"
                onChange={this.handleChange}
              />

              <InputText
                fullWidth
                name="technical_costs"
                value={technical_costs}
                label="Frais techniques"
                onChange={this.handleChange}
              />
            </Inline>

            <InputText
              margin
              rows={3}
              fullWidth
              multiline
              name="informations"
              value={informations}
              onChange={this.handleChange}
              label="Informations complémentaires"
            />
          </Panel>

          <Panel title="Montant et salariés">
            <Inline>
              <div style={{ width: '100%' }}>
                <InputText
                  fullWidth
                  type="number"
                  name="amount"
                  value={amount}
                  label="Montant de la commande*"
                  onChange={this.handleAmountChange}
                  onBlur={this.handleUpdateAmountPerUser}
                  errorText={errorMax && 'Le montant ne peut pas dépasser 999€ par utilisateur'}
                />
              </div>

              <InputText
                fullWidth
                type="number"
                name="users_count"
                value={users_count}
                label="Nombre de salariés*"
                onChange={this.handleAmountChange}
                onBlur={this.handleUpdateAmountPerUser}
              />
            </Inline>

            <InputText
              readOnly
              disabled
              fullWidth
              tabIndex={-1}
              name="amount_per_user"
              value={amount_per_user}
              label="Montant par salarié*"
              className={classes.formLine}
              errorText={errorAmount && 'Le montant de la commande divisé par le nombre de salariés doit être un nombre entier.'}
            />
          </Panel>

          <Panel title="Utilisateurs">
            {!users.length && <Typography variant="caption">Remplissez le champs "Nombre de salariés" pour pouvoir remplir cette partie.</Typography>}

            {users.length > 0 && (
              <UploadCSV
                onChange={this.handleImportCSV}
                disabled={errorMax || errorAmount}
              />
            )}

            {users.map((user, index) => {
              let errorEmail = user.errorEmail ? 'L\'adresse E-mail est invalide' : ''
              let errorPhone = user.errorPhone ? 'Le numéro de téléphone est invalide' : ''

              if (emailDuplicates.includes(user.email)) {
                errorEmail = 'L\'adresse e-mail est renseigné plusieurs fois'
              }

              if (phoneDuplicates.includes(user.phone)) {
                errorPhone = 'Le numéro de Téléphone est renseigné plusieurs fois'
              }

              return (
                <Inline
                  key={user.key}
                  className={classes.formLine}
                >
                  <InputText
                    fullWidth
                    tag="div"
                    name="email"
                    type="email"
                    label="E-mail"
                    value={user.email}
                    errorText={errorEmail}
                    disabled={errorMax || errorAmount}
                    onChange={this.handleUserChange(index)}
                    onBlur={this.handleValidateEmail(index)}
                  />

                  <InputText
                    fullWidth
                    tag="div"
                    name="phone"
                    label="Téléphone"
                    value={user.phone}
                    errorText={errorPhone}
                    disabled={errorMax || errorAmount}
                    onChange={this.handleUserChange(index)}
                    onBlur={this.handleValidatePhone(index)}
                  />

                  <div>
                    <IconButton
                      color="primary"
                      disabled={!user.email && !user.phone}
                      onClick={this.createSplitUserHandler(index)}
                    >
                      <DeleteOutlineOutlined />
                    </IconButton>
                  </div>
                </Inline>
              )
            })}
          </Panel>

          <Button
            fullWidth
            color="primary"
            variant="contained"
            isLoading={isLoading}
            className={classes.submit}
            onClick={this.handleSubmit}
            disabled={!this.isSubmitable() || errorDuplicate}
          >
            {isEdition ? 'Modifier' : 'Créer'}
          </Button>
        </form>
      </div>
    )
  }
}


AddOrder.propTypes = {
  item: PropTypes.object,
  addOrder: PropTypes.func.isRequired,
  getOrder: PropTypes.func.isRequired,
  editOrder: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  clients: PropTypes.arrayOf(PropTypes.object),
}


const mapStateToProps = state => ({
  item: state.item,
  clients: state.list.clients,
  isLoading: state.app.isLoading,
})


export default connect(mapStateToProps, {
  addOrder,
  getOrder,
  editOrder,
})(withStyles(styles)(AddOrder))
